<template>
  <div id="repayAccount">
    <div class="container">
      <headNav>
        <div slot="headNavText">{{$t('message.banksAccount')}}</div>
      </headNav>
      <div class="banksBox">
        <div class="accounts" v-for="(item,index) in banksArr" :key="index">
          <div><img :src="item.logo" alt=""></div>
          <div>
            <div style="color: #262626;margin-bottom: 8px">{{$t('message.repay_hm')}}:{{item.name}}</div>
            <div style="color: #262626;margin-bottom: 8px">{{$t('message.banksAccount')}}:{{item.card_number}}</div>
            <div style="color: #8A8A8A;margin-bottom: 8px">{{$t('message.repay_bank')}}:{{item.bank_type}}</div>
            <div style="color: #8A8A8A;">{{$t('message.repay_beizhu')}}:{{item.mark}}</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import headNav from "../../HeadNav/headNav";
  import {getBanksNews, sassSearchBanksList, deBankCard, postRenInfo, delBank} from '../../../ports/port'

  export default {
    name: "addBanks",
    data() {
      return {
        tk: JSON.parse(localStorage.getItem("tokenAll")),
        banksArr: [],//银行卡列表
      }
    },
    components: {
      headNav
    },
    created() {
      this.banksArr = JSON.parse(this.$route.query.data);
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
    },
    methods: {

    }
  }
</script>

<style scoped lang="scss">
  #repayAccount {
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    .container {
      background: #F5F5F5;
      padding: 0 0 1px;
      /*min-height: 77vh;*/
      flex: 1;

      .title {
        text-align: center;
        background: white;
        font-size: 16px;
        padding: 10px 0;
        border-bottom: 1px solid #F2F4FB;
        position: relative;

        i {
          position: absolute;
          left: 20px;
          font-size: 20px;
        }
      }

      .banksBox {
        padding: 55px 15px 0;
        .accounts{
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fff;
          padding: 0.3rem;
          border-radius: 8px;
          box-sizing: border-box;
          box-shadow: 0rem 0rem 0rem 0rem rgba(200, 200, 200, 0.49);
          margin-bottom: 15px;
          > :nth-child(1){
            width: 35%;
            margin-right: 10px;
            img{
              width: 100%;
            }
          }
          > :nth-child(2){
            width: 65%;
          }
        }
      }

      #add_bank_btn {
        @include defaultBtn;
        background-color: #fff!important;
        color: #242424;
        border: 1px solid #dad8d8;
        box-shadow: 0rem 0rem 0rem 0rem rgba(145, 145, 145, 0.4);
        border-radius: 8px!important;
      }
    }

    /deep/ .van-dialog__content {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/loanRecord/repay/repayAccount.vue